import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Typography } from '@mui/material';
// hooks
import useAuth from '../../../hooks/useAuth';
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { HEADER, NAVBAR } from '../../../config';
// components
import Logo from '../../../components/Logo';
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';
//
import AccountPopover from './AccountPopover';
import PauseSet from './PauseSet';

// import ContactsPopover from './ContactsPopover';
// import NotificationsPopover from './NotificationsPopover';
// import Searchbar from './Searchbar';

// ----------------------------------------------------------------------

const PORT = window.location.hostname === 'localhost' ? '8080' : '8443';

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout',
})(({ isCollapse, isOffset, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: 'none',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: '100%',
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));

// ----------------------------------------------------------------------

DashboardHeader.propTypes = {
  onOpenSidebar: PropTypes.func,
  isCollapse: PropTypes.bool,
  verticalLayout: PropTypes.bool,
};

export default function DashboardHeader({ onOpenSidebar, isCollapse = false, verticalLayout = false }) {
  const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  const isDesktop = useResponsive('up', 'lg');
  const { user } = useAuth();
  const [imageTimestamp, setImageTimestamp] = useState(Date.now());
  const imageUrl = `${window.location.protocol}//${window.location.hostname}:${PORT}/external-api/company-logo/${user?.company?._id}?t=${imageTimestamp}`;

   useEffect(() => {
    const handleLogoUpdate = () => {
      setImageTimestamp(Date.now());
    };
    window.addEventListener('company-logo-updated', handleLogoUpdate);
    
    return () => {
      window.removeEventListener('company-logo-updated', handleLogoUpdate);
    };
  }, []);

return (
  <RootStyle isCollapse={isCollapse} isOffset={isOffset} verticalLayout={verticalLayout}>
    <Toolbar
      sx={{
        minHeight: '100% !important',
        px: { lg: 5 },
      }}
    >
      {isDesktop && verticalLayout && <Logo sx={{ mr: 2.5 }} />}
      <object
        data={imageUrl}
        type="image/png"
        height={40}
      >
        <img src="/images/image-preview.png" alt={user?.company?.name || 'Logo'} height={40} />
      </object>
      <Typography variant="h6" color="#000" sx={{ ml: 2 }}>
        {user?.company?.name}
      </Typography>
      {!isDesktop && (
        <IconButtonAnimate onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButtonAnimate>
      )}
      <Box sx={{ flexGrow: 1 }} />

      <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
        {user.acl.profile !== 'master' && <PauseSet />}
        <AccountPopover />
      </Stack>
    </Toolbar>
  </RootStyle>
);
}
